// @ts-nocheck
import { name2num, num2name, } from "../../authority/(Authority)/AuthorityStatus";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as Long, } from "../../../../runtime/Long";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        userId: "0",
        authorityId: "0",
        authorityStatus: "AUTHORITY_STATUS_UNSPECIFIED",
        reason: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.userId !== undefined)
        result.userId = tsValueToJsonValueFns.int64(value.userId);
    if (value.authorityId !== undefined)
        result.authorityId = tsValueToJsonValueFns.int64(value.authorityId);
    if (value.authorityStatus !== undefined)
        result.authorityStatus = tsValueToJsonValueFns.enum(value.authorityStatus);
    if (value.reason !== undefined)
        result.reason = tsValueToJsonValueFns.string(value.reason);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.userId !== undefined)
        result.userId = jsonValueToTsValueFns.int64(value.userId);
    if (value.authorityId !== undefined)
        result.authorityId = jsonValueToTsValueFns.int64(value.authorityId);
    if (value.authorityStatus !== undefined)
        result.authorityStatus = jsonValueToTsValueFns.enum(value.authorityStatus);
    if (value.reason !== undefined)
        result.reason = jsonValueToTsValueFns.string(value.reason);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.userId !== undefined) {
        const tsValue = value.userId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.authorityId !== undefined) {
        const tsValue = value.authorityId;
        result.push([2, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.authorityStatus !== undefined) {
        const tsValue = value.authorityStatus;
        result.push([3, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.reason !== undefined) {
        const tsValue = value.reason;
        result.push([4, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.userId = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.authorityId = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.authorityStatus = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.reason = value;
    }
    return result;
}
